import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import { ApiUrls } from '@api/apiUrls';
import { DropdownLanguageSwitch } from '@components-library/DropdownLanguageSwitch/DropdownLanguageSwitch';
import { BonusPopupHeaderButton } from '@components-member/Bonuses/BonusPopup/BonusPopupHeaderButton';
import { HeaderQuickDeposit } from '@components-member/Header/HeaderQuickDeposit';
import { LoyaltyProgramHeaderPoints } from '@components-member/Pages/LoyaltyProgram/LoyaltyProgramHeaderPoints';
import { keyMap } from '@locales/lokalise/keyMap';
import sharedVariables from '@styles-shared/variables.scss';
import SignOut from 'components/shared/signOut';
import TAInfo from 'components/user/Header/TAInfo';
import WalletInfo from 'components/user/Header/WalletInfo';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';

interface IHeaderProps {
  displayMobileMenu: () => void;
}

const Header = observer(({ displayMobileMenu }: IHeaderProps) => {
  const { generalSettings, userInfo } = useMobxStore().accountStore;

  const { i18n } = useTranslation();
  const { profile, displayName } = userInfo;
  const { fullName } = profile;

  const isMobile = useMediaQuery({ query: `(max-width: ${sharedVariables.sm})` });

  return (
    <header className="header custom-web__header">
      <div className="container header__container">
        <div className="header__logo-container">
          <Link className="header__logo" to="/member">
            <img src={`${ApiUrls.branding.get}?p=lightlogo&h=${generalSettings.brandingHash}`} alt="Logo" />
          </Link>
        </div>
        <div className="header__left">
          <HeaderQuickDeposit />
          <WalletInfo />
          <TAInfo />
          {!isMobile && <LoyaltyProgramHeaderPoints />}
        </div>
        <div className="header__right">
          <BonusPopupHeaderButton />

          <div className="header__info-block">
            <div className="header__info-top">
              {i18n.t(keyMap.sharedWelcome)}
              <span className="header__info-name">{`${displayName || fullName}`}</span>
            </div>

            <div className="header__info-bottom">
              <SignOut />
            </div>
          </div>
          <DropdownLanguageSwitch />

          <button type="button" className="header__menu-btn" onClick={displayMobileMenu}>
            <i className="ico-bar" />
            <i className="ico-bar" />
            <i className="ico-bar" />
          </button>
        </div>
      </div>
    </header>
  );
});

export default Header;
